<template>
  <div :class="`zhandianbox ${type ? 'zhandianbox1' : ''}`">
    <div class="bg1 p10 h fs4 text-center color5">{{ title }}</div>
    <div class="zhandian">
      <div v-for="(item, index) in list" class="p10">
        <a :href="item.url">
          <p class="h pb10 fs2">{{ item.name }}</p>
          <p>
            <span class="blink1 h fs3">{{ item.signature.split(".")[0] }}</span>
            <span>.{{ item.signature.split(".")[1] }}</span>
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from "vue";
import { data2 } from "../utils/data";

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "站点推荐⬇⬇⬇⬇",
  },
});

const { list } = toRefs(props);
</script>

<style lang="scss" scoped>
.zhandianbox {
  border: 2px solid #008000;
}
.zhandian {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 12px;
  text-align: center;
  div {
    width: 100%;
    background-image: linear-gradient(to right, #80dffe, #d0d0ea, #e2e1b0);
    border-radius: 35px;
    a {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
.zhandianbox1 {
  .zhandian {
    gap: 5px;
    div {
      width: 100%;
      border-radius: 5px;
      background-color: #d3fffb !important;
      a {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>